import setting from './setting'

const set = {
  setting
}

export default set

export { set }